<div class="address-field-format">
  <h4><span class="formatText">format to</span></h4>
  <mat-select [(ngModel)]="formatSelected" (selectionChange)="changeValue($event.value)">
    <mat-option *ngFor="let o of formatTypes" [value]="o">{{format[o]}}</mat-option>
  </mat-select>
</div>
